import { combineReducers } from '@reduxjs/toolkit';
import { reducer as homeOverviewReducer } from './home/slice';
import { reducer as authReducer } from './auth/slice';
import { reducer as defiBalanceReducer } from './defi/balanceSlice';
import { reducer as defiTransactionsReducer } from './defi/transactionsSlice';
import { reducer as defiOverviewReducer } from './defi/overview';
import { reducer as clientReducer } from './clients/slice';
import { reducer as assetsReducer } from './assets/slice';
import { reducer as reportsReducer } from './reports/slice';
import { reducer as accountsReducer } from './accounts/slice';
import { reducer as dashboardReducer } from './dashboard/slice';
import { reducer as exchangesReducer } from './exchanges/slice';
import { reducer as snapshotsReducer } from './snapshots/slice';
import { reducer as protocolsReducer } from './protocols/slice';
import { reducer as contactReducer } from './contact/slice';
import { reducer as defiWalletDetailReducer } from './defi/walletDetailSlice';
import { reducer as hedgeFundsReducer } from './hedgeFunds/slice';
import { reducer as standardUserReducer } from './standardUsers/slice';
import { reducer as substandardUserReducer } from './subStandardUser/slice';
import { reducer as substandardUserTeamReducer } from './subStandardUserTeam/slice';
import { reducer as contractsReducer } from './contract/slice';
import { reducer as superAdminReducer } from './superAdmin/slice';
import { reducer as defiAssetReducer } from './defi/assetSlice';
import { reducer as defiChainReducer } from './defi/chainSlice';
import { reducer as exchangeTransactionsReducer } from './exchanges/transactionsSlice';
import { reducer as spotBalancesReducer } from './exchanges/spotBalanceSlice';
import { reducer as futureBalancesReducer } from './exchanges/futureBalanceSlice';
import { reducer as exchangeAccountsReducer } from './exchanges/exchangeAccountSlice';
import { reducer as exchangeOverviewReducer } from './exchanges/overview';
import { reducer as networkReducer } from './network/slice';
import { reducer as profileReducer } from './profile/slice';
import { reducer as subscriptionPlanReducer } from './subscriptionPlans/slice';

const appReducer = combineReducers({
  /**
   * All the reducers
   * that needs to be combined
   * will be added here
   */
  accounts: accountsReducer,
  assets: assetsReducer,
  auth: authReducer,
  clients: clientReducer,
  dashboard: dashboardReducer,
  defiBalance: defiBalanceReducer,
  defiOverview: defiOverviewReducer,
  transactions: defiTransactionsReducer,
  exchanges: exchangesReducer,
  homeOverview: homeOverviewReducer,
  protocols: protocolsReducer,
  reports: reportsReducer,
  snapshots: snapshotsReducer,
  contacts: contactReducer,
  defiWalletDetail: defiWalletDetailReducer,
  hedgeFunds: hedgeFundsReducer,
  standardUser: standardUserReducer,
  subStandardUser: substandardUserReducer,
  subStandardUserTeam: substandardUserTeamReducer,
  contracts: contractsReducer,
  superAdmin: superAdminReducer,
  defiAsset: defiAssetReducer,
  defiChain: defiChainReducer,
  exchangeTransactions: exchangeTransactionsReducer,
  exchangeSpotBalances: spotBalancesReducer,
  exchangeFutureBalances: futureBalancesReducer,
  exchangeAccounts: exchangeAccountsReducer,
  exchangeOverview: exchangeOverviewReducer,
  network: networkReducer,
  profile: profileReducer,
  subscriptionPlan: subscriptionPlanReducer,
});

const rootReducer = (state, action) => {
  // // Clear all data in redux store to initial.
  // if(action.type === "reset")
  //    state = undefined;

  return appReducer(state, action);
};

export default rootReducer;
